export const ACCEPT_SERVICE = {
  APPLICATION_JSON: "application/json",
  MULTIPART_DATA: "multipart/form-data",
  FORM_URL_ENCODED: "application/x-www-form-urlencoded",
  SPREADSHEAT_DATA:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PDF_FILE: "application/pdf",
};
export const DEFAULT_AUTH_TOKEN = "Basic c3RyaXgtdWk6";
export const DEFAULT_ACCEPT_SERVICE = ACCEPT_SERVICE.FORM_URL_ENCODED;
// export const GOOGLE_NETWORK_PING_URL =
//   "https://clients3.google.com/generate_204";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
 
export const AuthenticateUrl = process.env.REACT_APP_AUTHENTICATE_URL;
export class ApiUrl {
  static loginRequest = () => {
    return BASE_URL + "auth/authenticate";
  };
  static impersonateUser = () => {
    return BASE_URL + "auth/impersonate";
  };
  static refreshToken = () => {
    return BASE_URL + "auth/refresh";
  };
  static forgotPasswordRequest = (email) => {
    return BASE_URL + `auth/forgotpassword?email=${email}`;
  };
  static updatePasswordRequest = () => {
    return BASE_URL + "user/update";
  };
  static resetPasswordRequest = (token) => {
    return BASE_URL + `auth/reset?token=${token}`;
  };
  static userRequest = () => {
    return BASE_URL + `user`;
  };
  // static getAllUsers = (page, size, search,acctType,stsCd) => {
  //   if (search && search.length > 0) {
  //     return BASE_URL + `user?page=${page}&size=${size}&search=${search}&acctType=${acctType}&stsCd=${stsCd}`;
  //   } else {
  //     return BASE_URL + `user?page=${page}&size=${size}`;
  //   }
  // };

  static getAllUsers = (page, size, search, acctType, stsCd) => {
    const params = new URLSearchParams({ page, size });
  
    if (search) params.append('search', search);
    if (acctType) params.append('acctType', acctType);
    if (stsCd) params.append('stsCd', stsCd);
  
    return `${BASE_URL}user?${params.toString()}`;
  };
  
  static getAllUsersWithOUtPagination = (all) => {
    if (all) {
      return BASE_URL + `user/users?acctType=${all}`;
    } else {
      return BASE_URL + `user/users`;
    }
  };

  static getAllClientsWithOUtPagination = () => {
    return BASE_URL + `admin/clientswithoutpagination`;
  };

  static getUserById = (id) => {
    return BASE_URL + `user/${id}`;
  };
  
  static getBgCheckById = (id) => {
    return BASE_URL + `user/bgcheck/${id}`;
  }
  static editUser = (id) => {
    return BASE_URL + `user/${id}`;
  };
  static addClient = () => {
    return BASE_URL + "admin/client";
  };
  static getAllClients = (page, size, search) => {
    if (search && search.length > 0) {
      return (
        BASE_URL + `admin/clients?page=${page}&size=${size}&search=${search}`
      );
    } else {
      return BASE_URL + `admin/clients?page=${page}&size=${size}`;
    }
  };
  static projectRequest = () => {
    return BASE_URL + "admin/project";
  };
  static projectsListRequest = (page, size, search) => {
    if (search && search.length > 0) {
      return (
        BASE_URL + `admin/projects?page=${page}&size=${size}&search=${search}`
      );
    } else {
      return BASE_URL + `admin/projects?page=${page}&size=${size}`;
    }
  };

  static uploadFile = () => {
    return BASE_URL + "images/imageupload";
  };

  static editProject = (id) => {
    return BASE_URL + `admin/project/${id}`;
  };
  static editClient = (id) => {
    return BASE_URL + `admin/client/${id}`;
  };
  static getClientById = (id) => {
    return BASE_URL + `admin/client/${id}`;
  };
  static getProjectById = (id) => {
    return BASE_URL + `admin/project/${id}`;
  };

  static getProjectsByUserId = (id) => {
    if (id) {
      return BASE_URL + `admin/projects/${id}`;
    } else {
      return BASE_URL + `admin/userassociatedprojects`;
    }
  };

  static getTimeSheetsByProjectId = (uId, pId, date, page, size,sortby) => {
    let url = BASE_URL + `admin/${uId}/${pId}?page=${page}&size=${size}`;
    if (date) {
      url += `&fromDate=${date}`;
    }
    if (sortby) {
      url += `&sortby=${sortby}`;
    }
    return url;
  }

  static getTimeSheetsByProjectIdForUserPage = (pId, page, size) => {
    return BASE_URL + `timesheet/${pId}?page=${page}&size=${size}`;
  };

  static addTimeSheet = () => {
    return BASE_URL + "timesheet";
  };
  static getTimesheetById = (id) => {
    return BASE_URL + `timesheet/timesheetdetails/${id}`;
  };
  static editTimesheets = (id) => {
    return BASE_URL + `timesheet/edittimesheet/${id}`;
  };
  // static timesheetsAction =(id,action) =>{
  //   return BASE_URL  +`admin/${action}/${id}`
  // }
  static timesheetsAction = (id, action, remarks) => {
    return `${BASE_URL}admin/${action}/${id}?remarks=${encodeURIComponent(
      remarks
    )}`;
  };

  static getBackgroundImage = () => {
    return BASE_URL + "images/get";
  };

  static empStatusRequest = () => {
    return BASE_URL + "admin/adminemployeestatus";
  };
  static getEmpStatusRequest = (id) => {
    return BASE_URL + `admin/employeestatuseinfo/${id}`;
  };

  static getProjectsByuserId = (id, fromDate, toDate , page, size) => {
    if (fromDate && toDate) {
      return (
        BASE_URL +
        `admin/projectreportby/${id}?fromDate=${fromDate}&toDate=${toDate}&page=${page}&size=${size}`
      );
    } else {
      return BASE_URL + `admin/projectreportby/${id}?page=${page}&size=${size}`;
    }
  };

  static downloadFileRequest = (id, fileName, action) => {
    return (
      BASE_URL +
      `admin/${
        action === "download" ? "download" : "deleteempdocsfile"
      }/${id}/${fileName}`
    );
  };

  static getAllProjectsWithOutPagination = () => {
    return BASE_URL + `admin/allprojects`;
  };

  static generateProjectReport = () => {
    return BASE_URL + ``;
  };
  static generateInvoice = () => {
    return BASE_URL + `admin/generateinvoice`;
  };
  static getBudgetByProjectId = (pId,page,size) => {
    return BASE_URL + `admin/budgetreportby/${pId}?page=${page}&size=${size}`;
  };

  static getDocumentTypesRequest = () => {
    return BASE_URL + `admin/documenttypes`;
  };

  static uploadDocuments = () => {
    return BASE_URL + `admin/upload`;
  };

  static downloadInvoice = (id, invoiceId) => {
    return BASE_URL + `admin/getinvoice/${id}/${invoiceId}`;
  };

  static getAllListCount = () => {
    return BASE_URL + `admin/counts`;
  };

  static downloadTimeSheet = (fileId) => {
    return BASE_URL + `timesheet/download/${fileId}`;
  };

  static updateProfileUser = () => {
    return BASE_URL + "user/currentuserupdate";
  };
  static getExistingInvoices = (userId, projectName, fromDate,page, size, sortby) => {
    let url = BASE_URL + `admin/existinginvoice/${userId}/${projectName}?page=${page}&size=${size}`;
    if (fromDate) {
      url += `&fromDate=${fromDate}`;
    }
    if (sortby) {
      url += `&sortby=${sortby}`;
    }
    return url;
  };
  static updateInvoice =(invoiceId)=>{
    return BASE_URL + `admin/updateinvoice/${invoiceId}`;
  }

  static getAllTimesheet =( page, size, search, sortby)=>{
    let url = BASE_URL +`timesheet?status=SUB&page=${page}&size=${size}`;
    
    if (search && search.length > 0) {
      url += `&employeeName=${search}`;
    }
    
    if (sortby) {
      url += `&sortby=${sortby}`;
    }
    
    return url;
  }

    static getAllTimesheetApp =(  page, size, search, sortby  ) =>{
      let url = BASE_URL +`admin/allinvoices?page=${page}&size=${size}`;
      if (search && search.length > 0) {
        url += `&consultantName=${search}`;
      }
      if (sortby) {
        url += `&sortby=${sortby}`;
      }
      return url;
    }
    
  static reGenerateInvoicePDF = (invoiceId, rate = 0) => {
    return BASE_URL + `admin/generate-pdf?invoiceId=${invoiceId}&hourRate=${rate}`;
  }

  static invoicePaymentDateUpdate = () => {
    return BASE_URL + `admin/update-payment-date`;
  }

  static getEmpTimesheets = () => {
    return BASE_URL + "timesheet/emp-dashboard";
  }

  static getAllRejectedTimesheets =( page, size, search, sortby)=>{
    let url = BASE_URL +`timesheet?status=REJ&page=${page}&size=${size}`;
    
    if (search && search.length > 0) {
      url += `&employeeName=${search}`;
    }
    
    if (sortby) {
      url += `&sortby=${sortby}`;
    }
    
    return url;
  }

  static getAllToBeInvoicedTimesheets =( page, size, search, sortby)=>{
    let url = BASE_URL +`timesheet/approved-uninvoiced?&page=${page}&size=${size}`;
    
    if (search && search.length > 0) {
      url += `&employeeName=${search}`;
    }
    
    if (sortby) {
      url += `&sortby=${sortby}`;
    }
    
    return url;
  }
  static getAllToBeInvoicedTimesheetsByEmployeeAndProject =(eId, pId,sortby)=>{
    let url = BASE_URL +`timesheet/uninvoiced-timesheets-withoutpagination/${eId}/${pId}`;
    if (sortby) {
      url += `?sortby=${sortby}`;
    }
    return url;
  }

  static getAllEvents = (page, size,eventType,month) => {
    return BASE_URL + `admin/monthly-events?page=${page}&size=${size}&eventType=${eventType}&month=${month}`;
  }

  static getDashboardMonthlyHours = () => {
    return BASE_URL + `admin/monthly-approved-hours`;
  }

  static sendWorkAnniversaryWishes = (userId) => {
    return BASE_URL + `admin/work-anniversary/${userId}`;
  }

  static sendBirthdayWishes = (userId) => {
    return BASE_URL + `admin/bday/${userId}`;
  }

  static getAllQuotes = (page, size) => {
    return BASE_URL + `quotes?page=${page}&size=${size}`;
  }

  static addQuotes = () => {
    return BASE_URL + `quotes`;
  }

  static editQuotes = (id) => {
    return BASE_URL +  `quotes/${id}`;
  }

  static getQuoteById = (id) => {
    return BASE_URL + `quotes/${id}`
  }

  static getAllEventsNotifications = () => {
    return BASE_URL + `admin/events-notification`;
  }

  static downloadTimeSheetRequest = (id, fileId) => {
    return BASE_URL + `timesheet/download/${id}/${fileId}`;
  }

  static downloadFileById =(tId,fileId)=>{
    return BASE_URL +"timesheet/download/"+tId+"/"+fileId
   }
  static invoiceInfoById=(invoiceId)=>{
    return BASE_URL + `admin/invoiced-timesheets/${invoiceId}`;
  }


  static addAdminprefrence = () => {
    return BASE_URL + `admin/adminpreferences`;  
    }
  
  static getAdminprefrence = () => {
    return BASE_URL + `admin/getadminpreferences`;  }

  static getAdminprefrenceByName=(payload)=>{
    return BASE_URL + `admin/getamdminpreference/${payload}`
  }

    static editAdminPreference = (companyName) =>{
      return BASE_URL +`admin/updateadminpreferences/${companyName}`
    }   
    
    
    static getTimeOffRequests = (page, size, employeeName, sort, status) => {

      let url = BASE_URL + `timeoff/admin/requests?page=${page}&size=${size}&status=${status}&sort=${sort}`;
      if (employeeName) {
        url += `&employeeName=${employeeName}`;
      }
      
      return url;
    }

    static approveTimeOffRequest = (id, status) => {
      return BASE_URL + `timeoff/${id}/status?status=${status}`;
    }

    static getTimeOffById = (id) => {
      return BASE_URL + `timeoff/${id}`;
    }

    static updateTimeOffRequest = (id) => {
      return BASE_URL + `timeoff/${id}/update-by-admin`;
    }

    static createTimeOffRequest = (userId) => {
      return BASE_URL + `timeoff/admin/request/${userId}`;
    }

  
}
